import React from 'react'
import BbpsService from '../../myapp/services/bbps/BbpsService'

function BBPSPage() {
  return (
    <BbpsService/>
  )
}

export default BBPSPage